























































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import VueElementLoading from 'vue-element-loading';
import '../user-management.scss';
import { IKeyCloakUser, IEbkItem, IRegion } from '../user-management-int';
import BaseUserLink from '../base-user-link';
import { umFetch } from '../services/umFetch';

@Component({
  components: {
    loading: VueElementLoading,
  },
})
export default class AbpUserData extends BaseUserLink {
  @Prop({ default: "45" }) private oblRegion!: string;

  private abpBase: IEbkItem[] = [];
  private abpList: IEbkItem[] = [];
  private selectedUserAbpList: IEbkItem[] = [];
  private loading = false;
  private filterRegion: string | null = null;
  private filterAbp: number | null = null;
  private leftFilter = '';
  private rightFilter = '';
  private regionBase: IRegion[] = [];
  private right_max_count = 0;
  private showClosedAbp = false;
  private initialLoadComplete = false;
  private actualRegion: string | null = null;

get leftFilterAbpList() {
  let filtered = this.abpList;

  // ✅ если выбрали конкретную АБП (не null и не 0) — фильтруем
  if (this.filterAbp !== null && this.filterAbp !== 0) {
    const abpNum = Number(this.filterAbp);
    filtered = filtered.filter(item => Number(item.abp) === abpNum);
  }

  if (this.leftFilter.length > 0) {
    const search = this.leftFilter.toLowerCase();
    filtered = filtered.filter((item: any) => {
      const name = item.name_ru || '';
      return (
        item.abp.toString().includes(search) ||
        name.toLowerCase().includes(search)
      );
    });
  }

  return filtered;
}


  @Watch('showClosedAbp')
  async onShowClosedAbpChanged() {
    await this.loadAbpFromBase();
  }

  get rightFilterAbpList() {
    if (this.rightFilter.length === 0) {
      return this.selectedUserAbpList;
    }
    
    const search = this.rightFilter.toLowerCase();
    return this.selectedUserAbpList.filter(
      item =>
        item.abp.toString().includes(search) ||
        (item.name_ru && item.name_ru.toLowerCase().includes(search))
    );
  }

  get cols(): string {
    return this.isHasUmAdminRole ? "6" : "12";
  }

  @Watch('selectedUser')
  async onPropertyChanged(value: IKeyCloakUser, oldValue: IKeyCloakUser) {
    this.loading = true;
    try {
      this.resetAbpData();
      this.selectedUser = value;
      if (value) {
        await this.selectUser(value);
      }
    } finally {
      this.loading = false;
    }
  }
async mounted() {
  try {
    this.loading = true;
    this.resetAbpFilters();

    if (this.selectedUser && !this.initialLoadComplete) {
      await this.loadRegions(this.selectedUser);
      await this.loadUserFuncGroup(this.selectedUser);
      await this.refreshSelectedAbpFromBackend();
      this.initialLoadComplete = true;
    }
  } finally {
    this.loading = false;
  }
}


  private resetAbpData() {
    this.abpList = [];
    this.abpBase = [];
    this.filterRegion = null;
    this.filterAbp = null;
    this.leftFilter = '';
    this.rightFilter = '';
    this.initialLoadComplete = false;
  }

  private async loadRegions(user: IKeyCloakUser) {
    try {
      const response = await fetch(`/api-py/get-user-regions-by-obl/${this.oblRegion}/${user?.id}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      this.regionBase = data.map((item: any) => ({
        code: item.code?.toString() || '',
        name_ru: item.name_ru || item.name || `Регион ${item.code}`
      }));
    } catch (error) {
      this.regionBase = [];
      this.makeToast('danger', 'Ошибка загрузки', 'Не удалось загрузить список регионов');
    }
  }

 private async loadAbpFromBase() {
  if (!this.filterRegion) {
    this.abpList = [];
    this.abpBase = [];
    this.filterAbp = null;
    return;
  }

  this.loading = true;

  try {
    const response = await fetch(
      `/api-py/get-dict-user-abp-by-budget-level/${this.selectedUser?.id}?region_filter=${this.filterRegion}&include_closed_abp=${this.showClosedAbp}`
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    const allAbp: IEbkItem[] = data.map((item: any) => ({
      abp: Number(item.abp),
      name_ru: item.name_ru,
      end_date: item.end_date,
      region_code: item.region_code?.toString() ?? '',
      id: item.id ?? 0,
      gr: item.gr ?? 0,
      name_kk: item.name_kk ?? '',
      beg_date: item.beg_date ?? '2022-01-01',
      closed: !!item.closed
    }));

    this.abpBase = allAbp;

    const selectedAbpsSet = new Set(this.selectedUserAbpList.map(i => i.abp));

    this.abpList = allAbp
      .filter(item => !selectedAbpsSet.has(item.abp))
      .sort((a, b) => a.abp - b.abp);

  } catch (error) {
    this.makeToast('danger', 'Ошибка загрузки АБП', error.toString());
  } finally {
    this.loading = false;
  }
}


  private async refreshSelectedAbpFromBackend() {
  if (!this.selectedUser) return;

  this.loading = true;
  try {
    const queryParams = new URLSearchParams();
    if (this.filterRegion) {
      queryParams.append('region_filter', this.filterRegion);
    } else if (this.actualRegion) {
      // ✅ используем ранее выбранный регион, если пользователь уже выбирал
      queryParams.append('region_filter', this.actualRegion);
    }
    queryParams.append('include_closed_abp', String(this.showClosedAbp));

    const response = await fetch(`/api-py/get-selected-user-abp/${this.selectedUser.id}?${queryParams.toString()}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    const abpSeen = new Set<number>();

    this.selectedUserAbpList = data
      .map((item: any) => ({
        abp: Number(item.abp),
        name_ru: item.name_ru,
        end_date: item.end_date,
        closed: item.status === 'Закрытая'
      }))
      .filter((item: IEbkItem) => {
        if (abpSeen.has(item.abp)) return false;
        abpSeen.add(item.abp);
        return true;
      });

    this.selectedUserAbpList.sort((a, b) => a.abp - b.abp);
    this.initialLoadComplete = true;
  } catch (error) {
    this.makeToast('danger', 'Ошибка загрузки выбранных АБП', error.toString());
  } finally {
    this.loading = false;
  }
}

  
private async onRegionChanged() {
  this.actualRegion = this.filterRegion;

  this.abpList = [];
  this.abpBase = [];
  this.leftFilter = '';

  if (!this.filterRegion) return;
  if (this.filterAbp === 0) {
    await this.loadAbpFromBase();
  }
}





async filterAbpList() {
  if (this.filterAbp === 0) {
    if (!this.filterRegion) {
      this.abpList = [];
      this.abpBase = [];
      return;
    }

    await this.loadAbpFromBase();
    return;
  }

  if (this.filterAbp !== null) {
    const abpNum = Number(this.filterAbp);

    const selectedSet = new Set(this.selectedUserAbpList.map(i => i.abp));

    this.abpList = this.abpBase
      .filter(i => !selectedSet.has(i.abp))
      .filter(i => Number(i.abp) === abpNum)
      .sort((a, b) => a.abp - b.abp);

    return;
  }

  const selectedSet = new Set(this.selectedUserAbpList.map(i => i.abp));
  this.abpList = this.abpBase
    .filter(i => !selectedSet.has(i.abp))
    .sort((a, b) => a.abp - b.abp);
}


  private onLeftFilterInput() {
    if (this.leftFilter.length === 0) {
      const selectedAbps = new Set(this.selectedUserAbpList.map(item => item.abp));
      this.abpList = this.abpBase
        .filter(item => !selectedAbps.has(item.abp))
        .sort((a, b) => a.abp - b.abp);
    }
  }

  public async selectUser(user: IKeyCloakUser) {
    this.selectedUser = user;
    await this.loadRegions(user);
    await this.loadUserFuncGroup(user);
    await this.refreshSelectedAbpFromBackend();
  }

  private async loadUserFuncGroup(user: IKeyCloakUser) {
    if (!user) return;
    
    try {
      const response = await fetch(`/api-py/get-selected-user-abp/${this.selectedUser.id}?region_filter=${this.filterRegion}&include_closed_abp=${this.showClosedAbp}`);
      const data = await response.json();
      this.right_max_count = data.length;
    } catch (error) {
      this.makeToast('danger', 'Ошибка загрузки данных АБП: ' + user.id, error.toString());
    }
  }

  async removeAllAbp() {
    this.loading = true;
    try {
      if (!this.initialLoadComplete) {
        await this.refreshSelectedAbpFromBackend();
      }
      
      this.abpList.push(...this.selectedUserAbpList);
      this.abpList.sort((a, b) => a.abp - b.abp);
      this.selectedUserAbpList = [];
      
      await this.saveUserabpData(this.selectedUser);
    } finally {
      this.loading = false;
    }
  }

  async addAllAbp() {
    this.loading = true;
    try {
      if (!this.initialLoadComplete) {
        await this.refreshSelectedAbpFromBackend();
      }
      
      for (const abpListElement of this.abpList) {
        if (!this.selectedUserAbpList.find(value => value.abp === abpListElement.abp))
          this.selectedUserAbpList.push(abpListElement);
      }
      
      this.selectedUserAbpList.sort((a, b) => a.abp - b.abp);
      this.abpList = [];
      
      await this.saveUserabpData(this.selectedUser);
    } finally {
      this.loading = false;
    }
  }

  private async addAbpToSelectedUser(abp: IEbkItem, save: boolean) {
    this.loading = true;
    try {
      if (!this.initialLoadComplete) {
        await this.refreshSelectedAbpFromBackend();
      }
      
      if (!this.selectedUserAbpList.some(item => item.abp === abp.abp)) {
        this.selectedUserAbpList.push(abp);
      }
      
      this.abpList = this.abpList.filter(item => item.abp !== abp.abp);
      this.selectedUserAbpList.sort((a, b) => a.abp - b.abp);
      
      if (save) {
        await this.saveUserabpData(this.selectedUser);
      }
    } finally {
      this.loading = false;
    }
  }

  private async removeAbpFromSelectedUser(abp: IEbkItem, save: boolean) {
    this.loading = true;
    try {
      if (!this.initialLoadComplete) {
        await this.refreshSelectedAbpFromBackend();
      }
      
      this.selectedUserAbpList = this.selectedUserAbpList.filter(item => item.abp !== abp.abp);
      this.abpList.push(abp);
      this.abpList.sort((a, b) => a.abp - b.abp);
      
      if (save) {
        await this.saveUserabpData(this.selectedUser);
      }
    } finally {
      this.loading = false;
    }
  }

  private async saveUserabpData(user: IKeyCloakUser) {
    if (!user) return;
    
    if (!this.actualRegion && this.filterRegion) {
      this.actualRegion = this.filterRegion;
    }
    
    try {
      const abpList = this.selectedUserAbpList.map(item => ({ abp: item.abp }));
      const regionList = this.actualRegion ? [{ region: this.actualRegion }] : [];
      
      const saveData = {
        user_id: user.id,
        abpList,
        regionList,
      };
      
   const response = await umFetch('/api-py/save-user-abp', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Authorization': `Bearer ${this.$store.getters.token}`
  },
  body: JSON.stringify(saveData),
});

      
      if (!response.ok) throw new Error('Ошибка сохранения');
      
      this.makeToast('success', 'Сохранено', 'Данные АБП успешно сохранены');
    } catch (error) {
      this.makeToast('danger', 'Ошибка сохранения данных', error.toString());
      throw error;
    }
  }

  private resetAbpFilters() {
    this.filterRegion = null;
    this.filterAbp = null;
    this.leftFilter = '';
    this.rightFilter = '';
    this.showClosedAbp = false;
  }
}
